import Hud from '../../ui/hud/Hud';
import TexturedPanel from './TexturedPanel';

/*
    Content overlay panel

    Renders panel according to supplied dimensions, adds masked container spot
*/
export default class ContentPanel extends Phaser.Group {
  constructor(
    game,
    { width = 911, height = 458, padding = 20, cornerRadius = 30, content = false } = {}
  ) {
    super(game);

    this.onClosePanel = new Phaser.Signal();

    this.panel = new TexturedPanel(game, { width, height, corner: cornerRadius });
    this.add(this.panel);

    this.graphics = this.game.make.graphics();
    this.addChild(this.graphics);

    this.content = this.game.make.group();
    this.addChild(this.content);

    this.contentMask = this.game.make.graphics();
    this.content.mask = this.contentMask;
    this.addChild(this.contentMask);

    this.btnClose = Hud.CreateHudButtonFromId('close', this.game);
    this.btnClose.anchor.set(0.5);
    this.btnClose.events.onInputDown.add(this.handleClose, this);
    this.addChild(this.btnClose);

    this.setSize(width, height, padding, cornerRadius);

    if (content) {
      this.addContent(content);
    }
  }

  get width() {
    return this.panel.panelWidth;
  }

  get height() {
    return this.panel.panelHeight;
  }

  setSize(width = 911, height = 458, padding = 20, cornerRadius = 30) {
    this.panel.setSize({ width, height, corner: cornerRadius });

    this.contentMask.clear();
    this.contentMask.beginFill(0xff0000);
    this.contentMask.drawRoundedRect(padding, padding, width - padding * 2, height - padding * 2);

    this.btnClose.x = this.panel.width;
  }

  handleClose() {
    this.onClosePanel.dispatch(this);
  }

  addContent(displayItem, autoCenter = true) {
    if (autoCenter) {
      displayItem.x = this.width * 0.5 - displayItem.width * 0.5;
      displayItem.y = this.height * 0.5 - displayItem.height * 0.5;
    }
    this.content.add(displayItem);
  }

  destroy() {
    this.btnClose.destroy(true);
    this.btnClose = null;

    this.onClosePanel.removeAll();
    this.onClosePanel = null;

    this.graphics.destroy(true);
    this.graphics = null;
    this.contentMask.destroy(true);
    this.contentMask = null;
    this.content.destroy(true);
    this.content = null;

    super.destroy(true);
  }
}



// WEBPACK FOOTER //
// ./js/app/display/ui/ContentPanel.js